export { default as ProductCategoryList } from './ProductCategoryList';
export { default as ProductCategoryCreate } from './ProductCategoryCreate';
export { default as ProductCategoryEdit } from './ProductCategoryEdit';


// WEBPACK FOOTER //
// ./src/modules/ProductCategory/pages/index.ts